import React from 'react'
interface CreateStarChartTagFilterProps {
  listStatus: string
  onExperiences: () => void
  onOrganizations: () => void
}
export const CreateStarChartTagFilter: React.FC<CreateStarChartTagFilterProps> = ({
  listStatus,
  onExperiences,
  onOrganizations
}) => {
  return (
    <div className="starchart-filter-container filter-container">
      <div className="experiences " onClick={onExperiences}></div>
      <div className="organizations " onClick={onOrganizations} style={{pointerEvents:"none", cursor:"DisabledByDefault" , opacity:0.5}}></div>
      {listStatus === 'experiences'
        ? (
        <div className="expsActive" style={{ left: 0 }}></div>
          )
        : (
        <div className="expsActive" style={{ left: '148px' }}></div>
          )}
    </div>
  )
}